export function useBaseURL() {
  let baseURL = process.env.NEXT_PUBLIC_BASE_URL
  if (baseURL === undefined) {
    throw new Error('NEXT_PUBLIC_BASE_URL is not set.')
  }
  if (baseURL.includes('$NEXT_PUBLIC_BASE_URL_HOST')) {
    const baseURLHost = process.env.NEXT_PUBLIC_BASE_URL_HOST
    if (baseURLHost === undefined) {
      throw new Error('NEXT_PUBLIC_BASE_URL_HOST is not set.')
    }
    baseURL = baseURL.replace('$NEXT_PUBLIC_BASE_URL_HOST', baseURLHost)
  }
  return baseURL
}
